import styled from 'styled-components';
import chroma from 'chroma-js';

const borderColor = chroma('#f3fcff');

export default styled.div.attrs({
  className: 'code-description',
})`
  position: absolute;
  display: none;
  right: 0;
  bottom: 100%;
  background: ${borderColor.hex()};
  padding: 1rem;
  border: 1px solid ${borderColor.darken().hex()};
  border-radius: 0.5rem;
  box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.16);
  cursor: auto;

  &:after,
  &:before {
    top: 100%;
    right: 8px;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: rgba(255, 255, 255, 0);
    border-top-color: ${borderColor.hex()};
    border-width: 10px;
    margin-left: -10px;
  }

  &:before {
    border-color: transparent;
    border-top-color: ${borderColor.hex()};
    border-width: 11px;
  }
`;
